import React, { useState } from "react";

import isBetween from "dayjs/plugin/isBetween";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider, StaticDatePicker } from "@mui/x-date-pickers";

import { DateRangeValue } from "../types";
import { CustomDayProps, DateRangeDay } from "../DateRangeDay";

import dayjs, { Dayjs } from "dayjs";

dayjs.extend(isBetween);

interface DateRangeCalendarProps {
  onAccept?: (value: DateRangeValue | null) => void;
  onCancel?: () => void;
  value?: DateRangeValue | null;
}

const DateRangeCalendar: React.FC<DateRangeCalendarProps> = (props) => {
  const { onAccept, onCancel, value } = props;

  const [localValue, setLocalValue] = useState<DateRangeValue>({
    from: value?.from || null,
    to: value?.to || null,
  });

  const handleDateChange = (date: Dayjs | null) => {
    if (!date) return;
    const { from, to } = localValue;

    if (!from || (from && to)) {
      setLocalValue({ from: date, to: null });
      return;
    }

    if (date.isBefore(from, "day")) {
      setLocalValue({ from: date, to: null });
    } else {
      setLocalValue({ from, to: date });
    }
  };

  const handleAccept = () => {
    const { from, to } = localValue;

    if (from && !to) {
      onAccept?.({ from, to: from });
    } else {
      onAccept?.(localValue);
    }
  };

  return (
    <LocalizationProvider
      dateAdapter={AdapterDayjs}
      adapterLocale="uk"
      localeText={{ cancelButtonLabel: "Скасувати", okButtonLabel: "Ок" }}
    >
      <StaticDatePicker
        value={localValue?.from || localValue?.to}
        onChange={handleDateChange}
        slots={{ day: DateRangeDay, toolbar: () => null }}
        slotProps={{
          day: (ownerState) => {
            const { day } = ownerState;
            const { from, to } = localValue || {};

            return {
              isInRange:
                from && to && day && day.isBetween(from, to, "day", "[]"),
              isStartOfRange: from && day.isSame(from, "day"),
              isEndOfRange: to && day.isSame(to, "day"),
            } as unknown as CustomDayProps; // TODO
          },
          actionBar: {
            onAccept: handleAccept,
            onCancel: () => {
              onCancel?.();
            },
          },
          toolbar: {
            hidden: true,
          },
        }}
      />
    </LocalizationProvider>
  );
};

export default React.memo(DateRangeCalendar);
